import { metisSepolia } from '@/common-helpers/metisSepoliachain';
import { Chain } from 'wagmi/chains';
export const ADDRESS_ZERO = '0x0000000000000000000000000000000000000000';

export enum ChainId {
    metisTestnet = 59902,
    metisMainnet = 1088,
    mainnet = 1,
    testnet = 133718,
}

export const MainnetOnly = Number(import.meta.env.VITE_MAINNET_ONLY) === 1;

export const DefaultChainId = MainnetOnly ? ChainId.testnet : ChainId.testnet;

export const SupportChainIDs = MainnetOnly
    ? [ChainId.testnet]
    : [ChainId.testnet];

export const ProviderSupportChainId: Chain[] = [metisSepolia];

export const NETWORK_CONFIG = {
    [ChainId.mainnet]: {
        name: 'Ethereum Mainnet',
        scanLable: 'Etherscan',
        explore: 'https://etherscan.io/',
    },
    [ChainId.testnet]: {
        name: 'LazAI',
        scanLable: 'LazAI Testnet',
        explore: 'https://testnet-explorer.lazai.network/',
    },
    [ChainId.metisTestnet]: {
        name: 'Metis Sepolia Testnet',
        scanLable: 'Metis(Sepolia)-explore',
        explore: 'https://sepolia-explorer.metisdevops.link/',
    },
    [ChainId.metisMainnet]: {
        name: 'Andromeda',
        scanLable: 'Andromeda-explorer',
        explore: 'https://andromeda-explorer.metis.io/',
    },
};

export const SWITCH_NETWORK_CONFIG = {
    [ChainId.metisMainnet]: {
        chainId: `0x${ChainId.metisMainnet.toString(16)}`,
        chainName: 'Andromeda',
        nativeCurrency: {
            name: 'Metis Token',
            symbol: 'METIS',
            decimals: 18,
        },
        rpcUrls: [`https://andromeda.metis.io/?owner=${ChainId.metisMainnet}`],
        blockExplorerUrls: ['https://andromeda-explorer.metis.io'],
    },
    [ChainId.metisTestnet]: {
        chainId: `0x${ChainId.metisTestnet.toString(16)}`,
        chainName: 'Metis Sepolia',
        nativeCurrency: {
            name: 'Metis Token',
            symbol: 'METIS',
            decimals: 18,
        },
        rpcUrls: [
            'https://sepolia.metisdevops.link',
            // `https://stardust.metis.io/?owner=${ChainId.layer2Testnet}`,
        ],
        blockExplorerUrls: ['https://sepolia-explorer.metisdevops.link'],
    },
    [ChainId.mainnet]: {
        chainId: `0x${ChainId.mainnet.toString(16)}`,
        chainName: 'Ethereum Mainnet',
        nativeCurrency: {
            name: 'Ether',
            symbol: 'ETH',
            decimals: 18,
        },
        rpcUrls: ['https://mainnet.infura.io/v3/YOUR-PROJECT-ID'],
        blockExplorerUrls: ['https://etherscan.io'],
    },
    [ChainId.testnet]: {
        chainId: `0x${ChainId.testnet.toString(16)}`,
        chainName: 'LazAI Testnet',
        nativeCurrency: {
            name: 'LAZAI Testnet Token',
            symbol: 'LAZAI',
            decimals: 18,
        },
        rpcUrls: ['https://testnet.lazai.network'],
        blockExplorerUrls: ['https://testnet-explorer.lazai.network'],
    },
};

export const RPC = {
    [ChainId.metisMainnet]: 'https://andromeda-rpc.metis.io',
    [ChainId.metisTestnet]: 'https://sepolia.metisdevops.link',
    [ChainId.mainnet]: 'https://mainnet.infura.io/v3/YOUR-PROJECT-ID',
    [ChainId.testnet]: 'https://testnet.lazai.network',
};

export type Token = {
    name: string;
    symbol: string;
    decimals: number;
    address: string;
    img?: string;
};

export enum FaucetToken {
    metis = 'metis',
}

export enum MissionType {
    interactWithAI = 'interactWithAI',
    launchpadParticipation = 'launchpadParticipation',
    twitterFocusLazpad = 'twitterFocusLazpad',
    twitterShareLazpad = 'twitterShareLazpad',
    tgGroupJoin = 'tgGroupJoin',
    joinDiscord = 'joinDiscord',
    aiPlaygroundTasks = 'aiPlaygroundTasks',
    createAIAgent = 'createAIAgent',
}

export const Missions = [
    {
        id: MissionType.interactWithAI,
        title: 'Interact with AI Bot',
        description:
            'Ask insightful questions or complete guided tasks with our AI Assistant.',
        points: 20,
        link: '/aibot',
    },
    {
        id: MissionType.launchpadParticipation,
        title: 'Launchpad Participation',
        description:
            'Successful investments in Main Launchpad projects can earn you points. ',
        points: 12,
        link: '/',
    },
    {
        id: MissionType.twitterFocusLazpad,
        title: 'Follow on X.com',
        description:
            'Follow Lazpad.fun or partner projects on X.com (Twitter).',
        points: 12,
        link: 'https://x.com/CorruptedAlith',
    },
    {
        id: MissionType.twitterShareLazpad,
        title: 'Share Project on X.com',
        description: 'Share Lazpad project details to your X.com followers.',
        points: 20,
        link: 'https://x.com/CorruptedAlith',
    },
    {
        id: MissionType.tgGroupJoin,
        title: 'Join Telegram',
        description:
            'Become an active member of the Lazpad or partner project communities.',
        points: -1,
        link: 'https://t.me/lazai_global',
    },
    {
        id: MissionType.joinDiscord,
        title: 'Join Discord',
        description:
            'Become an active member of the Lazpad or partner project communities.',
        points: -1,
        link: 'https://discord.gg/lazpad',
    },
    {
        id: MissionType.aiPlaygroundTasks,
        title: 'AI Playground Tasks',
        description:
            'Explore and interact with various AI Agents, complete unique tasks.',
        points: -1,
        link: '/',
    },
    {
        id: MissionType.createAIAgent,
        title: 'Create AI Agent',
        description:
            'Create your own AI Agent or be an early trader on the bonding curve.',
        points: -1,
        link: '/',
    },
];

export const MetisAddress = '0xDeadDeAddeAddEAddeadDEaDDEAdDeaDDeAD0000';

export const OFFICIAL_X = 'https://x.com/LazAINetwork';

export const OFFICIAL_TELEGRAM = 'https://t.me/lazai_global';

export const LAZAI_TELEGRAM = 'https://t.me/lazai_global';

export const FAUCET = 'https://faucet.lazai.network';

export const isTestEnv = import.meta.env.VITE_TEST === '1';
